import { readCsrfCookie } from '@/lib/api/cookies.js';
import type { components } from '@/lib/api/schema.js';

import { createSessionStore } from './session-store.js';

export type UserDto = components['schemas']['UserDto'];

/**
 * Пользовательское пространство токенов. CSRF-токен на старте берётся из cookie:
 * на холодной загрузке страницы ответа сервера, из которого его можно было бы прочитать,
 * ещё не было, а восстановить сессию без него нельзя.
 */
export const userSessionStore = createSessionStore<UserDto>(readCsrfCookie());
